export interface IListagemComunicacao {
    IdOrganizacao: number;
    IdCanal: number;
    Canal: string;
    IdComunicacao: number;
    Comunicacao: string;
    TextoCliente: string;
    ComunicacaoDescricao: string;
    IdCampanhaExt: string;
    ComunicacaoTipo: string;
    IdCampanhaCampo: string;
    ComunicacaoTitulo: string;
    UrlImagem: string;
    AcaoAndrd: string;
    AcaoIos: string;
    CdComunicacaoExt: string;
    CampanhaExtStatus: string;
    IdComunicacaoExt: string;
    MGCONFCOM_IND_GRP_CONTR_EXT: string;
    MGCONFCOM_CD_COM_GC_EXT: string;
    DtAtualiazacao: Date;
    IdFornecedora: number;
    Fornecedora: string;
    AssuntoEmail: string;
    RemetenteEmail: string;
    NomeRemetenteEmail: string;
    RespostaEmail: string;
    NomePasta: string;
    NomeArquivo: string;
    ROW_NUM: number
}

export interface IListagemComunicacaoLog {
    ORG_CD: number;
    Codigo: number;
    Canal: string;
    IdComunicacao: number;
    MGCONFCOMLOG_NM: string;
    MGCONFCOMLOG_TX_CLIENTE: string;
    MGCONFCOMLOG_DS: string;
    MGCONFCOMLOG_ID_CAMPANHA_EXT: string;
    MGCONFCOMLOG_TP_TEMPLATE: string;
    MGCONFCOMLOG_ID_CAMPANHA_CAMPO: string;
    MGCONFCOMLOG_TITULO: string;
    MGCONFCOMLOG_URL_IMAGEM: string;
    MGCONFCOMLOG_CLK_ACAO_ANDR: string;
    MGCONFCOMLOG_CLK_ACAO_IOS: string;
    MGCONFCOMLOG_CD_EXT: string;
    MGCONFCOMLOG_FL_STAT_CMP_EXT: string;
    MGCONFCOMLOG_ID_EXT: string;
    MGCONFCOMLOG_IND_GRP_CTR_EXT: string;
    MGCONFCOMLOG_CD_COM_GC_EXT: string;
    DATA_ATUALIZACAO: string;
    Acao: string;
    COMFORN_ID: number;
    Fornecedora: string;
    MGCONFCOMLOG_TX_ASSUNTO_EMAIL: string;
    MGCONFCOMLOG_TX_REMETENTE_EML: string;
    MGCONFCOMLOG_NM_REMETENTE_EML: string;
    MGCONFCOMLOG_TX_RESP_EMAIL: string;
    MGCONFCOMLOG_NM_PASTA: string;
    MGCONFCOMLOG_NM_ARQUIVO: string;
    ROW_NUM: number
}

export interface IResponseComunicacaoLog {

    count: number;
    rows: IListagemComunicacaoLog[];

}


export interface IResponseComunicacao {

    count: number;
    rows: IListagemComunicacao[];

}

export interface ICreateComunicacao {
    IdCanal?: number,
    Comunicacao?: string,
    TextoCliente?: string,
    ComunicacaoDescricao?: string,
    IdCampanhaExt?: string,
    IdCampanhaCampo?: string,
    ComunicacaoTipo?: string,
    ComunicacaoTitulo?: string,
    urlImagem?: string,
    acaoAndrd?: string,
    acaoIos?: string,
    cdComunicacaoExt?: string,
    dhIniExt?: Date,
    dhFinExt?: Date,
    campanhaExtStatus?: string,
    idComunicacaoExt?: string,
    qtdDisparo?: string,
    cdMalaDireta?: string,
    indGrpContrExt?: string,
    cdComGcExt?: string,
    idCampanha?: number,
    idFornecedora?: number,
    AssuntoEmail?: string,
    RemetenteEmail?: string,
    NomeRemetenteEmail?: string,
    RespostaEmail?: string,
    nomePasta?: string,
    nomeArquivo?: string,
    
}

export const InicitalCreateComunicacao = {


  IdCanal: 0,
  Comunicacao: '',
  TextoCliente: '',
  ComunicacaoDescricao: '',
  IdCampanhaExt: '',
  IdCampanhaCampo: '',
  ComunicacaoTipo: '',
  ComunicacaoTitulo: '',
  urlImagem: '',
  acaoAndrd: '',
  acaoIos: '',
  cdComunicacaoExt: '',
  dhIniExt: new Date(),
  dhFinExt: new Date(),
  campanhaExtStatus: '',
  idComunicacaoExt: '0',
  qtdDisparo: '',
  cdMalaDireta: '',
  indGrpContrExt: '',
  cdComGcExt: '',
  idCampanha: 0,
  IdFornecedora: 0,
  AssuntoEmail: '',
  RemetenteEmail: 'crmpefisa@crmpefisa.pernambucanas.com.br',
  NomeRemetenteEmail: 'Pernambucanas',
  RespostaEmail: 'noreply@crmpefisa.pernambucanas.com.br',
  nomePasta: '',
  nomeArquivo: ''

};  

export interface IHelpTags {
	TagDadosVariaveis: string,
    NomeDadosVariaveis: string,
    TamMaxDadosVariaveis: number,
    DescDadosVariaveis:string,

ROW_NUM: number
}

export interface IResponseHelptag {

    count: number;
    rows: IHelpTags[];

}
